import { render, staticRenderFns } from "./HomeQuickActions.vue?vue&type=template&id=56a95f76"
import script from "./HomeQuickActions.vue?vue&type=script&lang=js"
export * from "./HomeQuickActions.vue?vue&type=script&lang=js"
import style0 from "./HomeQuickActions.vue?vue&type=style&index=0&id=56a95f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports